import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";

function SvgMission(props) {
  return _jsxs("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    children: [_jsx("mask", Object.assign({
      id: "mission_svg__a",
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 64,
      height: 64
    }, {
      children: _jsx("path", {
        fill: "#fff",
        d: "M0 0h64v64H0z"
      }, void 0)
    }), void 0), _jsxs("g", Object.assign({
      mask: "url(#mission_svg__a)",
      strokeWidth: 3,
      strokeLinecap: "round"
    }, {
      children: [_jsx("path", {
        d: "M23.591 19.428c.075-.196.16-.392.23-.578.216-.54.58-1.007 1.051-1.346a3.023 3.023 0 014.448 1.055l18.362 35.074a2.307 2.307 0 01-.884 3.062c-.34.196-.724.301-1.116.305H9.58a2.27 2.27 0 01-1.907-1.029 2.3 2.3 0 01-.192-2.167c3.499-8.232 5.643-12.992 9.138-21.229",
        stroke: "#7373FF",
        strokeMiterlimit: 10
      }, void 0), _jsx("path", {
        d: "M42.768 35.103l.86-1.507a2.04 2.04 0 011.764-1.027 2.026 2.026 0 011.765 1.027l12.732 22.168a.823.823 0 01-.296 1.121.812.812 0 01-.409.11h-5.943",
        stroke: "#7373FF",
        strokeLinejoin: "round"
      }, void 0), _jsx("path", {
        d: "M18.547 7H4.515A.516.516 0 004 7.518v8.639c0 .286.23.517.515.517h14.032a.516.516 0 00.515-.517v-8.64A.516.516 0 0018.547 7zM19.062 7.633v20.51",
        stroke: "#FF6652",
        strokeMiterlimit: 10
      }, void 0)]
    }), void 0)]
  }), void 0);
}

export default SvgMission;